import { CREATE_TICKET, CREATE_TICKET_SUCCESS, CREATE_TICKET_ERROR } from "../actions";

export const createTicket = (params) => ({
    type: CREATE_TICKET,
    params
});

export const createTicketSuccess = (payload) => ({
    type: CREATE_TICKET_SUCCESS,
    payload
});

export const createTicketError = (error) => ({
    type: CREATE_TICKET_ERROR,
    payload: error
});
